module.exports = __webpack_public_path__ + "img/Navbarlogo.f207c4ea.png";